var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"mt-5 mb-3"},[_c('LoadingSpinner',{attrs:{"is-loaded":_vm.pageLoaded}},[(_vm.pageSlug !== '' && _vm.page)?_c('PageDetail',{attrs:{"page":_vm.page}}):_c('NotFound')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }